import { api } from '../axios';

export const historyClaimAttendance = async () => {
  const res = await api.get(`/event/history-claim-daily-attendance-duty`);
  return res.data;
};

export const claimAttendance = async () => {
  return await api.post(`/event/claim-daily-attendance-duty`);
};

export const getFirstSubs = async () => {
  const res = await api.get(`/event/event-first-subscription`);
  return res.data;
};

export const postFirstSubs = async () => {
  return await api.post(`/event/event-first-subscription`);
};
